import React from 'react';
import { Item } from './styles';
import {
  formatTimestamp,
  formatValue,
  getActiveErrors,
  BatteryProtection,
  BatterySelfLatchOpen,
  BatteryAlarm1,
  BatteryAlarm2,
} from './utils';

const mosfet = (on) => on === undefined || on === null ? "N/A" : (on ? "on" : "off");

const alarms = (flags1, flags2) => [
  ...getActiveErrors(BatteryAlarm1, flags1 & 0xFFFF),
  ...getActiveErrors(BatteryAlarm2, flags2 & 0xFFFF),
].join(', ');

export default function BatteryDanTech({ data }) {
  if (!data) return null;

  return (
    <Item>
      <h3 style={{ marginBlockEnd: 0 }}>DanTech battery</h3>
      {Object.entries(data).map(([sensor_id, d]) => (
        <div key={d.id || d.timestamp}>
          {formatTimestamp(d.timestamp)}{d.frequency && <> - {formatValue(d.frequency, 1)} Hz</>}
          <p style={{ marginLeft: '1em' }}>
            {`SoC: ${formatValue(d.soc)} %`}<br />
            {`Voltage: ${formatValue(d.pack_voltage, 2)} V`}<br />
            {`Current: ${formatValue(d.pack_current, 2)} A`}<br />
            {`Power: ${formatValue(d.pack_voltage * d.pack_current, 1)} W`}<br />
            {`Temperature: ${formatValue(d.average_temperature, 1)} °C (${formatValue(d.min_temperature, 1)} - ${formatValue(d.max_temperature, 1)} °C)`}<br />
            {`Cell voltage: ${formatValue(d.cell_voltage_min, 3)} - ${formatValue(d.cell_voltage_max, 3)} V (spread ${formatValue(d.cell_voltage_spread * 1000, 0)} mV)`}<br />
            {`Capacity: ${formatValue(d.remaining_capacity, 1)} / ${formatValue(d.full_charge_capacity, 1)} Ah`}<br />
            {`Cycles: ${d.cycle_count ?? "N/A"}`}<br />
            {`MOSFET: charge ${mosfet(d.charge_mosfet_on)}, discharge ${mosfet(d.discharge_mosfet_on)}`}<br />
            {(d.protection_flags & BatterySelfLatchOpen) > 0 && <>Self-latch switch: open<br /></>}
            {(d.protection_flags & ~BatterySelfLatchOpen) > 0 &&
              <div>Protection: {getActiveErrors(BatteryProtection, d.protection_flags & ~BatterySelfLatchOpen)?.join(', ')}</div>}
            {(d.alarm_level1_flags1 > 0 || d.alarm_level1_flags2 > 0) &&
              <div>Alarm 1: {alarms(d.alarm_level1_flags1, d.alarm_level1_flags2)}</div>}
            {(d.alarm_level2_flags1 > 0 || d.alarm_level2_flags2 > 0) &&
              <div>Alarm 2: {alarms(d.alarm_level2_flags1, d.alarm_level2_flags2)}</div>}
            {(d.alarm_level3_flags1 > 0 || d.alarm_level3_flags2 > 0) &&
              <div>Alarm 3: {alarms(d.alarm_level3_flags1, d.alarm_level3_flags2)}</div>}
          </p>
        </div>
      ))}
    </Item>
  );
}
